<!--
 * @Description: 经营者信息
 * @Date: 2025-09-12 17:45:57
-->
<template>
  <BaseTextTitle>经营者信息</BaseTextTitle>
  <BaseTextContent>
    <BaseForm label-position="top" disabled :model="formData" :column-count="4">
      <BaseFormItem
        label="姓名"
        prop="operator"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="formData.operator"
        />
      </BaseFormItem>
      <BaseFormItem
        label="联系电话"
        prop="phone"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="formData.phone"
        />
      </BaseFormItem>
      <BaseFormItem
        label="身份证号"
        prop="idcard"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          clearable
          v-model="formData.idcard"
        />
      </BaseFormItem>

      <BaseFormItem
        style="grid-column-start: 1; grid-column-end: 3"
        label="身份证国徽面"
        prop="cardIdFront"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseImage
          style="width: 100%; height: 200px"
          fit="contain"
          :src="formData.cardIdFront"
          :preview-src-list="[formData.cardIdFront]"
        />
      </BaseFormItem>
      <BaseFormItem
        style="grid-column-start: 3; grid-column-end: 5"
        label="身份证人像面"
        prop="cardIdBack"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseImage
          style="width: 100%; height: 200px"
          fit="contain"
          :src="formData.cardIdBack"
          :preview-src-list="[formData.cardIdBack]"
        />
      </BaseFormItem>
    </BaseForm>
  </BaseTextContent>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseInput,
  BaseTextContent,
  BaseTextTitle,
  BaseForm,
  BaseImage
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';

const formData = defineModel<IndividualInfoDetailData>();
</script>
